// BFSG
import * as React from 'react'
import styled from 'styled-components'
import Logo from '../../../../../static/images/logo.svg'
import theme from 'theme'
import Link from 'theme/atoms/Link'

export default function Head() {
  return (
    <Wrapper className="Head" data-cy-ctx="app/Head">
      <Link
        to="/"
        aria-label="Back to shop" // TODO: bfsg snippet
      >
        <img src={Logo} alt="Logo" data-cy-handle="back-to-shop" />
      </Link>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 25px;

  @media (min-width: ${theme.ms.MD}px) {
    margin-top: ${theme.spacing('l')};
  }

  > a {
    display: inline-block;
    &:focus {
      outline: revert;
      outline-width: 2px;
      outline-offset: 22px;
    }
  }

  > a > img {
    display: flex;
    height: 40px;
    cursor: pointer;

    @media (min-width: ${theme.ms.MD}px) {
      margin-top: -10px;
    }
  }
`
